import React from "react"

import Layout from "../components/layout"
import Header from "../components/header"
import SEO from "../components/seo"
import Features from "../components/features"
import Portfolio from "../components/portfolio"
import About from "../components/about"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Header />
    <Features />
    <About />
    <Portfolio />
  </Layout>
)

export default IndexPage
